export default __webpack_public_path__ + "src/assets/unidaiBreakdown.62a0e431025ff7d86671aa9702e713f8.svg";